var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21,
    r: 21,
    fill: "#EDEFF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 21.2597L21.4974 26.3396V17.3535V7L12.75 21.2597Z",
    fill: "#898989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4976 7V17.3535V26.3396L30.245 21.2597L21.4976 7Z",
    fill: "#323232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 17.3547L30.2448 21.2598L21.5 26.3384V17.3547Z",
    fill: "#141414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4974 17.3535L21.5 17.3544V26.3371L21.4974 26.3397L12.75 21.2597L21.4974 17.3535Z",
    fill: "#373737"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 22.8894L21.4974 34.9999V27.9668L12.75 22.8894Z",
    fill: "#898989"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4976 27.9668V34.9999L30.2502 22.8894L21.4976 27.9668Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.dff89413151cd02549c09979d2d40cfd.svg";
export { ForwardRef as ReactComponent };